import { ITranslationModel } from "@models/interface-management/localization";

export interface IDicBase {
  id?: string;
  code?: string;
  name: ITranslationModel;
}

export interface IDicList {
  id: string;
  name: string | ITranslationModel;
}

export enum DataAvailabilityQueryParameterEnum {
  NotDeleted,
  Deleted,
  All,
}

export interface IPropertyInfo {
  name: string;
  description: string;
  value: number;
}
